export var EhApplicationTypeEnum;
(function (EhApplicationTypeEnum) {
    EhApplicationTypeEnum["Complaint"] = "Complaint";
    EhApplicationTypeEnum["RoutineRecurring"] = "Routine Recurring";
    EhApplicationTypeEnum["RoutineAdhoc"] = "Routine Ad hoc";
    EhApplicationTypeEnum["RequestHealthCertificate"] = "Request for Health Certificate";
    EhApplicationTypeEnum["FoodRemovalCertificate"] = "Food removal certificate";
    EhApplicationTypeEnum["CommunicableDisease"] = "Communicable disease";
})(EhApplicationTypeEnum || (EhApplicationTypeEnum = {}));
